import { assetStakingTxData } from './asset-staking-tx-data.js'

const getTxStakingData = ({ assetName, currency, tx }) => {
  return assetStakingTxData[assetName]({ tx, currency })
}

const processTxLog = async ({ asset, assetClientInterface: aci, walletAccount, batch }) => {
  const { name: assetName, currency } = asset
  const txs = await aci.getTxLog({ assetName, walletAccount })

  const newTxs = []
  for (const tx of txs) {
    const stakingData = getTxStakingData({ assetName, currency, tx })
    if (stakingData) {
      newTxs.push({
        ...tx,
        coinAmount: currency.ZERO,
        data: { ...tx.data, ...stakingData },
      })
    }
  }

  if (newTxs.length > 0) {
    aci.updateTxLogAndNotifyBatch({ assetName, walletAccount, txs: newTxs, batch })
  }
}

export default processTxLog
